module.exports = __webpack_public_path__ + "static/e0c5760e-a92c-4638-ab37-4f6feb6f9f12-b40a5ef7a3083eecd6e70feda12768ae.webp";